<template>
  <div class="testScheduling">
    <el-upload
        ref="my-upload"
        class="upload-demo"
        drag
        action="#"
        :limit="1"
        :on-change="beforeUpload"
        :on-exceed="handleExceed"
        :auto-upload="false"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">
        只能上传xls/xlsx文件，且不超过1MB
      </div>
    </el-upload>
    <el-button
        type="primary"
        @click="submitUpload"
        style="margin-top: 15px"
        :loading="loading"
    >提交
    </el-button
    >
    <el-button @click="returnPage">返回</el-button>
    <div class="errContent" v-if="errorMsg">
      <h4 style="line-height: 44px; font-weight: normal">{{ errorMsg }}</h4>
      <div
          class="errorContent"
          v-for="(item, index) in errorContent"
          :key="index"
          style="margin-bottom: 10px"
      >
        <p style="text-align: left; margin-bottom: 10px">{{ item.name_zh }}</p>
        <el-alert
            v-for="(item, index) in item.errorMsg"
            :key="index"
            :title="item"
            type="error"
            :closable="false"
            style="margin-bottom: 10px"
        >
        </el-alert>
      </div>
    </div>
    <br/>
    <!--  补考弹窗  -->
    <el-dialog title="提示" :visible.sync="showRetake" :width="screenWidth>768?'40%':'90%'" center
               :close-on-click-modal="false">
      <div>
        <div style="margin-bottom: 1em" v-for="(it,index) in retakeList" :key="index">
          <p style="text-align: left; margin-bottom: 10px">{{ it.name_zh }}</p>
          <el-alert type="error" :closable="false">
            学员{{ it.name_zh }}有一条请假记录
          </el-alert>
        </div>
        <div>
          如已参加补考请联系仁洲体育工作人员进行成绩录入，成绩审核通过后再进行下一级别报名；
        </div>
        <div>
          如本次在原报名机构进行补考，无需进行报名缴费，将此学员信息在报名表中删除；
        </div>
        <div>如需放弃上次考试资格，请联系仁洲体育工作人员进行处理，处理后可报考原报名级别</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRetake = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//   import { getStore } from "@/util/store";
import {
  BulkRegistration,
  ImportTestSchedult,
  ImportTestResult,
} from "@/api/admin/test.js";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      files: "",
      fileName: "",
      id: 0,
      test_class_id: 0,
      formData: {},
      errorMsg: "",
      errorContent: [],
      loading: false,
      showRetake: false,
      retakeList: []
    };
  },
  computed: {
    ...mapGetters(["screenWidth"])
  },
  created() {
    //   let  importResults = getStore({ name: "importResults" });
    this.id = this.$route.query.id;
    this.test_class_id = this.$route.query.test_class_id;
  },
  methods: {
    handleExceed() {
      this.$message.warning(
          "当前限制选择 1 个文件,如需更换文件请先删除已上传的"
      );
    },
    beforeUpload(file) {
      this.errorMsg = "";
      this.errorContent = [];
      this.files = file.raw;
      const extension = file.name.split(".")[1] === "xls";
      const extension2 = file.name.split(".")[1] === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!extension && !extension2) {
        this.$message.error("上传模板只能是 xls、xlsx格式!");
        return false; // 返回false不会自动上传
      }
      if (!isLt2M) {
        this.$message.error("上传模板大小不能超过 1MB!");
        return false;
      }
      this.fileName = file.name;
      return;
    },
    submitUpload() {
      if (this.fileName == "") {
        this.$message.warning("请选择要上传的文件！");
        return false;
      }
      this.formData.file = this.files;
      this.formData.test_class_id = this.test_class_id;
      this.formData.isFormSubmit = true;
      this.loading = true;

      if (this.id == 1) {
        BulkRegistration(Object.assign(this.formData)).then((data) => {
          if (data.data.success) {
            let res = data.data.result;
            if (res.isSuccess) {
              this.loading = false;
              this.$message({
                message: res.errorMsg,
                type: "success",
              });
              this.$router.go(-1);
            } else {
              if (res.data.retakeList && res.data.retakeList.length) {
                this.retakeList = res.data.retakeList;
                this.showRetake = true;
              }
              this.$message.error("提交失败");
              this.loading = false;
              this.fileName = "";
              this.$refs["my-upload"].clearFiles();
              this.errorMsg = res.errorMsg;
              if (!(res.data.errorList && res.data.errorList.length) && res.data.retakeList && res.data.retakeList.length) {
                this.errorMsg = '';
              }
              if (res.data.errorList) {
                this.errorContent = res.data.errorList;
              }
            }
          }
        });
      } else if (this.id == 2) {
        ImportTestSchedult(Object.assign(this.formData)).then((data) => {
          let list = data.data.result;
          if (list.isSuccess) {
            this.loading = false;
            this.$message({
              message: list.errorMsg,
              type: "success",
            });
            this.$router.go(-1);
          } else {
            this.errMethod(list);
          }
        });
      } else {
        this.$confirm('请确认本次请假学员已标记？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ImportTestResult(Object.assign(this.formData)).then((data) => {
            let list = data.data.result;
            if (list.isSuccess) {
              this.loading = false;
              this.$alert(list.errorMsg, '系统提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                  this.$router.go(-1);
                }
              });
            } else {
              this.errMethod(list);
            }
          });
        }).catch(() => {
          this.loading = false;
        })
      }
    },
    //返回
    returnPage() {
      this.$router.go(-1);
    },
    errMethod(list) {
      this.$message.error("提交失败");
      this.loading = false;
      this.fileName = "";
      this.$refs["my-upload"].clearFiles();
      this.errorMsg = list.errorMsg;
      if (list.items) {
        this.errorContent = list.items;
      }
    },
  },
};
</script>

<style lang="less">
.testScheduling {
  text-align: center;

  .el-upload {
    width: 60%;
    margin: auto;

    .el-upload-dragger {
      width: 100%;
    }
  }

  .errContent {
    width: 60%;
    margin: auto;
    margin-top: 20px;
  }
}
</style>
